import React from "react";
import CheckMultiplePermission from "../../roles/CheckMultiplePermission";
import { MenuSeparator } from "../../navigation/styles";
import MenuItem from "../../metis/MenuItem";
import MenuLink from "../../metis/MenuLink";
import {
      CareerIcon,
      CheckListIcon,
      ComplaintIcon,
      ElementIcon,
} from "../../dashboard";

const WebsiteManage = ({ userPermissions }) => {
      return (
            <>
                  <CheckMultiplePermission
                        userPermissions={userPermissions}
                        permissions={[
                              "banner-list",
                              "banner-edit",
                              "banner-create",
                              "banner-show",
                              "plugin-list",
                              "plugin-create",
                              "plugin-edit",
                              "plugin-show",
                              "testimonial-list",
                              "testimonial-create",
                              "testimonial-edit",
                              "testimonial-show",
                              "job-list",
                              "job-edit",
                              "job-create",
                              "job-show",
                              "complain-list",
                              "complain-show",
                              "complain-type-list",
                              "complain-type-show",
                              "complain-type-edit",
                              "complain-type-create",
                              "candidate-list",
                              "candidate-show",
                              "subscriber-list",
                              "contact-request-list",
                              "contact-request-show",
                              "client-list",
                              "client-create",
                              "client-edit",
                              "client-show",
                              "associate-list",
                              "associate-create",
                              "associate-edit",
                              "associate-delete",
                              "associate-order-manage",
                              "concern-list",
                              "concern-create",
                              "concern-edit",
                              "concern-delete",
                              "associate-category-list",
                              "associate-category-create",
                              "associate-category-edit",
                              "associate-category-show",
                        ]}
                  >
                        <MenuSeparator>Website Manage</MenuSeparator>
                        <CheckMultiplePermission
                              userPermissions={userPermissions}
                              permissions={[
                                    "associate-list",
                                    "associate-create",
                                    "associate-edit",
                                    "associate-delete",
                                    "associate-order-manage",
                                    "associate-category-list",
                                    "associate-category-create",
                                    "associate-category-edit",
                                    "associate-category-show",
                              ]}
                        >
                              <MenuItem
                                    title="Associate Manage"
                                    icon={<ElementIcon />}
                                    links={[
                                          "/dashboard/associates",
                                          "/dashboard/associates/create",
                                          "/dashboard/associates/:associateId/edit",
                                          "/dashboard/associates/:associateId/show",
                                          "/dashboard/associates/order/manage",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "associate-list",
                                                "associate-edit",
                                                "associate-create",
                                                "associate-show",
                                                "associate-order-manage",
                                                "associate-category-list",
                                                "associate-category-create",
                                                "associate-category-edit",
                                                "associate-category-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Associate List"
                                                link="/dashboard/associates"
                                                links={[
                                                      "/dashboard/associates",
                                                      "/dashboard/associates/create",
                                                      "/dashboard/associates/:associateId/edit",
                                                      "/dashboard/associates/:associateId/show",
                                                ]}
                                          />
                                          <MenuLink
                                                title="Category List"
                                                link="/dashboard/association_categories"
                                                links={[
                                                      "/dashboard/association_categories",
                                                      "/dashboard/association_categories/create",
                                                      "/dashboard/association_categories/:categoryId/edit",
                                                      "/dashboard/association_categories/:categoryId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>
                        <CheckMultiplePermission
                              userPermissions={userPermissions}
                              permissions={[
                                    "concern-list",
                                    "concern-create",
                                    "concern-edit",
                                    "concern-delete",
                                    "concern-order-manage",
                              ]}
                        >
                              <MenuItem
                                    title="Concern Manage"
                                    icon={<ElementIcon />}
                                    links={[
                                          "/dashboard/associates",
                                          "/dashboard/associates/create",
                                          "/dashboard/associates/:associateId/edit",
                                          "/dashboard/associates/:associateId/show",
                                          "/dashboard/associates/order/manage",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "concern-list",
                                                "concern-edit",
                                                "concern-create",
                                                "concern-show",
                                                "concern-order-manage",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Concern List"
                                                link="/dashboard/concerns"
                                                links={[
                                                      "/dashboard/concerns",
                                                      "/dashboard/concerns/create",
                                                      "/dashboard/concerns/:concernId/edit",
                                                      "/dashboard/concerns/:concernId/show",
                                                      "/dashboard/concerns/order/manage",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>
                        <CheckMultiplePermission
                              userPermissions={userPermissions}
                              permissions={[
                                    "job-list",
                                    "job-edit",
                                    "job-create",
                                    "job-show",
                                    "candidate-list",
                                    "candidate-show",
                              ]}
                        >
                              <MenuItem
                                    title="Career Manage"
                                    icon={<CareerIcon />}
                                    links={[
                                          "/dashboard/jobs",
                                          "/dashboard/jobs/create",
                                          "/dashboard/jobs/:jobId/edit",
                                          "/dashboard/jobs/:jobId/show",
                                          "/dashboard/candidates",
                                          "/dashboard/candidates/create",
                                          "/dashboard/candidates/:candidateId/edit",
                                          "/dashboard/candidates/:candidateId/show",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "job-list",
                                                "job-create",
                                                "job-edit",
                                                "job-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="All Job"
                                                link="/dashboard/jobs"
                                                links={[
                                                      "/dashboard/jobs",
                                                      "/dashboard/jobs/create",
                                                      "/dashboard/jobs/:jobId/edit",
                                                      "/dashboard/jobs/:jobId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "candidate-list",
                                                "candidate-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Candidate List"
                                                link="/dashboard/candidates"
                                                links={[
                                                      "/dashboard/candidates",
                                                      "/dashboard/candidates/create",
                                                      "/dashboard/candidates/:candidateId/edit",
                                                      "/dashboard/candidates/:candidateId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>

                        <CheckMultiplePermission
                              userPermissions={userPermissions}
                              permissions={[
                                    "complain-list",
                                    "complain-show",
                                    "complain-type-list",
                                    "complain-type-show",
                                    "complain-type-edit",
                                    "complain-type-create",
                              ]}
                        >
                              <MenuItem
                                    title="Complaint Manage"
                                    icon={<ComplaintIcon />}
                                    links={[
                                          "/dashboard/complains",
                                          "/dashboard/complains/create",
                                          "/dashboard/complains/:complainId/edit",
                                          "/dashboard/complains/:complainId/show",
                                          "/dashboard/complains/types",
                                          "/dashboard/complains/types/create",
                                          "/dashboard/complains/types/:typeId/edit",
                                          "/dashboard/complains/types/:typeId/show",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "complain-list",
                                                "complain-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="All Complaint"
                                                link="/dashboard/complains"
                                                links={[
                                                      "/dashboard/complains",
                                                      "/dashboard/complains/create",
                                                      "/dashboard/complains/:complainId/edit",
                                                      "/dashboard/complains/:complainId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>

                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "complain-type-list",
                                                "complain-type-show",
                                                "complain-type-edit",
                                                "complain-type-create",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Complaint Type"
                                                link="/dashboard/complains/types"
                                                links={[
                                                      "/dashboard/complains/types",
                                                      "/dashboard/complains/types/create",
                                                      "/dashboard/complains/types/:typeId/edit",
                                                      "/dashboard/complains/types/:typeId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>
                        <CheckMultiplePermission
                              userPermissions={userPermissions}
                              permissions={[
                                    "banner-list",
                                    "banner-edit",
                                    "banner-create",
                                    "banner-show",
                                    "client-list",
                                    "client-create",
                                    "client-edit",
                                    "client-show",
                                    "plugin-list",
                                    "plugin-create",
                                    "plugin-edit",
                                    "plugin-show",
                                    "testimonial-list",
                                    "testimonial-create",
                                    "testimonial-edit",
                                    "testimonial-show",
                              ]}
                        >
                              <MenuItem
                                    title="Element Manage"
                                    icon={<ElementIcon />}
                                    links={[
                                          "/dashboard/banners",
                                          "/dashboard/banners/create",
                                          "/dashboard/banners/:bannerId/edit",
                                          "/dashboard/banners/:bannerId/show",
                                          "/dashboard/clients",
                                          "/dashboard/clients/create",
                                          "/dashboard/clients/:clientId/edit",
                                          "/dashboard/clients/:clientId/show",
                                          "/dashboard/plugins",
                                          "/dashboard/plugins/create",
                                          "/dashboard/plugins/:pluginId/edit",
                                          "/dashboard/plugins/:pluginId/show",
                                          "/dashboard/testimonials",
                                          "/dashboard/testimonials/create",
                                          "/dashboard/testimonials/:testimonialId/edit",
                                          "/dashboard/testimonials/:testimonialId/show",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "client-list",
                                                "client-edit",
                                                "client-create",
                                                "client-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Client"
                                                link="/dashboard/clients"
                                                links={[
                                                      "/dashboard/clients",
                                                      "/dashboard/clients/create",
                                                      "/dashboard/clients/:clientId/edit",
                                                      "/dashboard/clients/:clientId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "banner-list",
                                                "banner-edit",
                                                "banner-create",
                                                "banner-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Banner"
                                                link="/dashboard/banners"
                                                links={[
                                                      "/dashboard/banners",
                                                      "/dashboard/banners/create",
                                                      "/dashboard/banners/:bannerId/edit",
                                                      "/dashboard/banners/:bannerId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "plugin-list",
                                                "plugin-create",
                                                "plugin-edit",
                                                "plugin-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Plugins"
                                                link="/dashboard/plugins"
                                                links={[
                                                      "/dashboard/plugins",
                                                      "/dashboard/plugins/create",
                                                      "/dashboard/plugins/:pluginId/edit",
                                                      "/dashboard/plugins/:pluginId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "testimonial-list",
                                                "testimonial-create",
                                                "testimonial-edit",
                                                "testimonial-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Testimonial"
                                                link="/dashboard/testimonials"
                                                links={[
                                                      "/dashboard/testimonials",
                                                      "/dashboard/testimonials/create",
                                                      "/dashboard/testimonials/:testimonialId/edit",
                                                      "/dashboard/testimonials/:testimonialId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>

                        <CheckMultiplePermission
                              userPermissions={userPermissions}
                              permissions={[
                                    "subscriber-list",
                                    "contact-request-list",
                                    "contact-request-show",
                              ]}
                        >
                              <MenuItem
                                    title="Frontend Form"
                                    icon={<CheckListIcon />}
                                    links={[
                                          "/dashboard/subscribers",
                                          "/dashboard/subscribers/create",
                                          "/dashboard/subscribers/:subscriberId/edit",
                                          "/dashboard/subscribers/:subscriberId/show",
                                          "/dashboard/contact/requests",
                                          "/dashboard/contact/requests/create",
                                          "/dashboard/contact/requests/:contactId/edit",
                                          "/dashboard/contact/requests/:contactId/show",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={["subscriber-list"]}
                                    >
                                          <MenuLink
                                                title="Subscriber List"
                                                link="/dashboard/subscribers"
                                                links={[
                                                      "/dashboard/subscribers",
                                                      "/dashboard/subscribers/create",
                                                      "/dashboard/subscribers/:subscriberId/edit",
                                                      "/dashboard/subscribers/:subscriberId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>

                                    <CheckMultiplePermission
                                          userPermissions={userPermissions}
                                          permissions={[
                                                "contact-request-list",
                                                "contact-request-show",
                                          ]}
                                    >
                                          <MenuLink
                                                title="Contact Request"
                                                link="/dashboard/contact/requests"
                                                links={[
                                                      "/dashboard/contact/requests",
                                                      "/dashboard/contact/requests/create",
                                                      "/dashboard/contact/requests/:contactId/edit",
                                                      "/dashboard/contact/requests/:contactId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>
                  </CheckMultiplePermission>
            </>
      );
};

export default WebsiteManage;
